import React from 'react';
import styles from './index.module.scss';

//Components
import { Pagination } from 'react-bootstrap';

const CustomPagination = ({ current, total, setPage, className, limit }) => {
    const PreItems = (props) => (
        <>
            <Pagination.Item onClick={() => setPage(1)}>1</Pagination.Item>
            <Pagination.Ellipsis />
        </>
    );

    const MidItems = () => {
        const spanLimit = Math.ceil(limit / 2);

        // It doesnt have no pre-pro items
        if (total <= limit) {
            return (
                <>
                    {[...Array(total)].map((item, index) => (
                        <Pagination.Item
                            key={'pitem-' + index}
                            onClick={() => setPage(index + 1)}
                            active={current === (index + 1)}>{index + 1}</Pagination.Item>
                    ))}
                </>
            );
        }

        // It doesnt have pre-items
        if (spanLimit >= current) {

            return (
                <>
                    {[...Array(limit)].map((item, index) => (
                        <Pagination.Item
                            key={'pitem-' + index}
                            onClick={() => setPage(index + 1)}
                            active={current === (index + 1)}>{index + 1}</Pagination.Item>
                    ))}
                    <ProItems />
                </>
            );
        }

        // It has both pre and pro items
        if (spanLimit < current && current < (total - spanLimit)) {
            const startIndex = (current - spanLimit) + 1;

            return (
                <>
                    <PreItems />
                    {[...Array(limit)].map((item, index) => {
                        return (
                            <Pagination.Item
                                key={'pitem-' + startIndex}
                                onClick={() => setPage(index + startIndex)}
                                active={current === (index + startIndex)}>{index + startIndex}</Pagination.Item>
                        )
                    })}
                    <ProItems />
                </>
            );
        }

        // It has no pro items
        const startIndex = (total - limit) + 1;
        return (
            <>
                <PreItems />
                {[...Array(limit)].map((item, index) => {
                    return (
                        <Pagination.Item
                            key={'pitem-' + startIndex}
                            onClick={() => setPage(index + startIndex)}
                            active={current === (index + startIndex)}>{index + startIndex}</Pagination.Item>
                    )
                })}
            </>
        );

    }

    const ProItems = (props) => (
        <>
            <Pagination.Ellipsis />
            <Pagination.Item onClick={() => setPage(total)}>{total}</Pagination.Item>
        </>
    );

    return (
        <Pagination size="sm" className={[styles.CustomPagination, className].join(' ')}>
            <MidItems />
        </Pagination>
    );
};

export default CustomPagination;